import {
  ProductDetailsAddToBagButton,
  ProductDetailsBackButton,
  ProductDetailsBanner,
  ProductDetailsChangeLocationButton,
  ProductDetailsColumn,
  ProductDetailsContainer,
  ProductDetailsContentBlock,
  ProductDetailsCost,
  ProductDetailsHeader,
  ProductDetailsIngredient,
  ProductDetailsIngredientsStack,
  ProductDetailsLabel,
  ProductDetailsLink,
  ProductDetailsNavigationHeader,
  ProductDetailsNutritionData,
  ProductDetailsNutritionEntries,
  ProductDetailsNutritionist,
  ProductDetailsSectionTitle,
  ProductDetailsTabs,
  ProductDetailsText,
  ProductDetailsTextSeparator,
  ProductDetailsTitle,
  ProductDetailsUnavailableProduct,
} from './components';

export const ProductDetails = {
  Container: ProductDetailsContainer,
  Column: ProductDetailsColumn,
  ContentBlock: ProductDetailsContentBlock,
  Banner: ProductDetailsBanner,
  Header: ProductDetailsHeader,
  NavigationHeader: ProductDetailsNavigationHeader,
  Nutritionist: ProductDetailsNutritionist,
  Label: ProductDetailsLabel,
  BackButton: ProductDetailsBackButton,
  Title: ProductDetailsTitle,
  SectionTitle: ProductDetailsSectionTitle,
  Text: ProductDetailsText,
  TextSeparator: ProductDetailsTextSeparator,
  Cost: ProductDetailsCost,
  AddToBagButton: ProductDetailsAddToBagButton,
  ChangeLocationButton: ProductDetailsChangeLocationButton,
  NutritionData: ProductDetailsNutritionData,
  NutritionEntries: ProductDetailsNutritionEntries,
  Tabs: ProductDetailsTabs,
  IngredientsStack: ProductDetailsIngredientsStack,
  Ingredient: ProductDetailsIngredient,
  Link: ProductDetailsLink,
  UnavailableProduct: ProductDetailsUnavailableProduct,
};

export { useProductDetailsNavigationHeaderHeight } from './components';
